import "core-js/modules/es6.object.assign";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { renderFormMixins } from '@/mixins/renderFormMixins';
import { getgrouplist } from '@/api/auth';
import { company_list } from '@/api/xinli';
export default {
  name: "addAccout",
  mixins: [renderFormMixins],
  data: function data() {
    return {
      showCompany: true,
      mechanismList: [],
      time: 120,
      vcodeLoading: false,
      vcodeText: '获取验证码',
      vcodeStatus: true,
      states: [{
        value: 0,
        label: "禁用"
      }, {
        value: 1,
        label: "启用"
      }],
      reqBase: {
        page: 1,
        page_size: 100
      },
      formValidate: {
        admin_name: null,
        admin_real_name: null,
        admin_password: null,
        code: null,
        group_codes: [],
        company_code: null,
        company_name: null
      },
      roleData: [],
      formRules: {
        company_code: [{
          required: true,
          message: '请选择所属机构',
          trigger: 'blur'
        }],
        admin_name: [{
          required: true,
          message: '请输入帐号',
          trigger: 'blur'
        }],
        code: [{
          required: true,
          message: '验证码不能为空',
          trigger: 'blur'
        }],
        admin_real_name: [{
          required: true,
          message: '请输入姓名',
          trigger: 'blur'
        }],
        admin_password: [{
          required: true,
          message: '请输入密码',
          trigger: 'change'
        }, {
          pattern: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,20}$/,
          message: '6-20位，至少包含字母数字其中两种'
        }],
        group_codes: [{
          required: true,
          type: 'array',
          message: '请选择角色',
          trigger: 'change'
        }],
        company_name: [{
          required: true,
          message: '请输入企业名称',
          trigger: 'change'
        }]
      }
    };
  },
  props: {
    _vm: {},
    edit: {},
    $store: {},
    setData: {}
  },
  components: {},
  computed: {
    getCompanyCode: function getCompanyCode() {
      return this.$store.state.user.companyCode;
    },
    getUserInfo: function getUserInfo() {
      return this.$store.state.user.userInfo;
    }
  },
  methods: {
    init: function init() {
      var _this = this;

      this.roleData.splice(0); // company_list({page:1,page_size:-1}).then(res=>{
      //   if(res.result===0){
      //     let data=res.body.list
      //     for(let list in data){
      //       this.mechanismList.push({
      //         label:data[list].company_name,
      //         value:data[list].company_code
      //       })
      //     }
      //   }
      // })

      getgrouplist({}).then(function (res) {
        if (res.result === 0) {
          _this.roleData = res.body.list || [];
        }
      });
    },
    mombileChange: function mombileChange(value) {
      if (!/^1[3456789]\d{9}$/.test(value)) {
        this.vcodeStatus = false;
      } else {
        this.vcodeStatus = true;
      }
    },
    changeTime: function changeTime() {
      var vm = this;
      this.vcodeStatus = true;
      var timeInterval = setInterval(function () {
        if (vm.time > 0) {
          vm.time--;
          vm.vcodeText = vm.time + 's获取验证码';
        } else {
          clearInterval(timeInterval);
          vm.vcodeStatus = false;
          vm.vcodeText = '重新获取验证码';
        }
      }, 1000);
    },
    //获取验证码
    clickVcode: function clickVcode() {
      var _this2 = this;

      this.vcodeLoading = true;

      this._vm.$store.dispatch("authCenter/handlegetsms", {
        mobile: this.formValidate.admin_name,
        type: 1
      }).then(function (res) {
        _this2.vcodeLoading = false;

        if (res.result === 0) {
          _this2.$Message.success(_this2.$t('验证码发送成功'));

          _this2.changeTime();
        } else {
          _this2.$Message.error(res.errorMsg);
        }
      });
    }
  },
  mounted: function mounted() {
    this.init();
  },
  created: function created() {
    if (this.edit) {
      Object.assign(this.formValidate, this.setData);
      this.$set(this.formValidate, 'admin_name', this.setData.user_name);

      if (this.formValidate.account_type === 1) {
        this.showCompany = true;
      } else {
        this.showCompany = false;
      }
    }
  }
};